module.exports = __webpack_public_path__ + "static/media/rose1.6d6639e5.jpeg";